import { validDomain } from '@/modules/common/validators/domainValidation'
import { Ref } from '@vue/composition-api'
import useVuelidate from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'

interface TeamDnsOverridesValidatorParams {
  chinaOverride: Ref<string>
  internationalOverride: Ref<string>
}

const useTeamDnsOverridesValidator = (params: TeamDnsOverridesValidatorParams) => {
  const { chinaOverride, internationalOverride } = params
  const rules = {
    chinaOverride: {
      validDomain: helpers.withMessage('Domain name must have a valid format', validDomain)
    },
    internationalOverride: {
      validDomain: helpers.withMessage('Domain name must have a valid format', validDomain)
    }
  }

  return {
    validator: useVuelidate(rules, { chinaOverride, internationalOverride })
  }
}

export default useTeamDnsOverridesValidator
